module.exports = __webpack_public_path__ + "static/media/p6_1.ece47bc7.png";